
import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';

import { filter, withLatestFrom, map } from 'rxjs/operators';
import { Actions } from '../../actions';

import { UpdateArtist } from '../../artist/action-creators';
import { UPDATE_ARTIST } from '../../artist/actions';
import AppState from '../../state';
import User from '@common/types/user/user';
import { UpdateUser } from '../action-creators';


export const updateUserAvatarEpic = (action$: Observable<Actions>, state$: StateObservable<AppState>) =>
  action$.pipe(
    ofType<Actions, UpdateArtist>(UPDATE_ARTIST),
    filter((action) => action.artist.type === 'solo' && !!action.artist.avatar),
    withLatestFrom(state$),
    filter(([_, state]) => !!state.user.profile?.id && !state.user.profile?.avatar),
    map(([action, state]) => {
      const profile: Partial<User> = {
        ...state.user.profile,
        avatar: action.artist.avatar
      };

      return new UpdateUser(profile);
    })
  );